export default __webpack_public_path__ + "static/media/Profiles.d7c6a3f5.svg";